module.exports = __webpack_public_path__ + "img/xlkc_fwsm.ba13d298.png";